import React, { useState, useRef, useEffect } from 'react';
import { BOOKING_STATUSES, STATUS_LABELS, STATUS_COLORS } from '../../constants/statuses';

const StatusFilter = ({ selectedStatuses, onStatusChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleStatusToggle = (status) => {
    const newStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter(s => s !== status)
      : [...selectedStatuses, status];
    
    onStatusChange(newStatuses);
  };

  const handleSelectAll = () => {
    const allStatuses = Object.values(BOOKING_STATUSES);
    onStatusChange(selectedStatuses.length === allStatuses.length ? [] : allStatuses);
  };

  const getDisplayText = () => {
    if (selectedStatuses.length === 0) {
      return 'No statuses selected';
    }
    if (selectedStatuses.length === Object.values(BOOKING_STATUSES).length) {
      return 'All statuses';
    }
    if (selectedStatuses.length === 1) {
      return STATUS_LABELS[selectedStatuses[0]];
    }
    return `${selectedStatuses.length} statuses selected`;
  };

  return (
    <div className="status-filter" ref={dropdownRef}>
      <button
        className="status-filter-button"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="filter-icon">🏷️</span>
        <span className="filter-text">{getDisplayText()}</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="status-filter-dropdown">
          <div className="status-filter-header">
            <button
              className="select-all-button"
              onClick={handleSelectAll}
              type="button"
            >
              {selectedStatuses.length === Object.values(BOOKING_STATUSES).length ? 'Deselect All' : 'Select All'}
            </button>
          </div>
          
          <div className="status-filter-options">
            {Object.entries(BOOKING_STATUSES).map(([key, status]) => (
              <label key={status} className="status-option">
                <input
                  type="checkbox"
                  checked={selectedStatuses.includes(status)}
                  onChange={() => handleStatusToggle(status)}
                />
                <span className="status-option-text">{STATUS_LABELS[status]}</span>
                <span 
                  className="status-indicator"
                  style={{ 
                    backgroundColor: STATUS_COLORS[status] 
                  }}
                />
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusFilter;
